export const titles = [
  {
    slug: 'course_duration',
    text: 'тривалість курсу',
  },
  {
    slug: 'count_of_lessons',
    text: 'Кількість занять',
  },
  {
    slug: 'regularity_of_lessons',
    text: 'Регулярність занять',
  },
  {
    slug: 'lesson_duration',
    text: 'тривалість заняття',
  },
  {
    slug: 'schedule',
    text: 'Графік',
  },
]

export const beforeElement =
  '[&:not(:last-child)]:before:absolute [&:not(:last-child)]:before:h-full [&:not(:last-child)]:before:w-0.5 [&:not(:last-child)]:before:right-0'
